import React from "react";
import SingleService from "../../components/Service";
import Breadcrumb from "../../components/Breadcrumb";
import CTA from "../../components/CTA";

import bgImg from "../../assets/img/cta/cta-bg.png";
import serviceIconBg1 from "../../assets/img/service/sv-icon-shape-13.png";
import serviceIconBg2 from "../../assets/img/service/sv-icon-shape-14.png";
import serviceIconBg3 from "../../assets/img/service/sv-icon-shape-15.png";
import serviceIconBg4 from "../../assets/img/service/sv-icon-shape-16.png";
import serviceIconBg5 from "../../assets/img/service/sv-icon-shape-17.png";
import serviceIconBg6 from "../../assets/img/service/sv-icon-shape-18.png";
import serviceIconBg7 from "../../assets/img/service/sv-icon-shape-19.png";
import serviceIconBg8 from "../../assets/img/service/sv-icon-shape-20.png";
import serviceIconBg9 from "../../assets/img/service/sv-icon-shape-21.png";
import serviceIconBg10 from "../../assets/img/service/sv-icon-shape-24.png";
import serviceIconBg11 from "../../assets/img/service/sv-icon-shape-22.png";
import serviceIconBg12 from "../../assets/img/service/sv-icon-shape-23.png";

const ServiceMain = () => {
  return (
    <main>
      <Breadcrumb pageTitle="Our Services" />

      <div className="service__area service__plr mt-100 mb-20 p-relative">
        <div className="container-fluid">
          <div className="row">
            {/* Service 1: ERP & CRM Solutions */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-1"
                titleClass="service__title color-1"
                descClass="text-white"
                serviceIcon="fal fa-plug"
                serviceIconBg={serviceIconBg1}
                Title="ERP & CRM Solutions"
                Description="Leverage our comprehensive ERP & CRM systems designed to integrate data and streamline operations, enhancing customer engagement and driving efficiency."
                btnText="Read More"
                btnURL="services/erp-crm"
              />
            </div>
            {/* Service 2: Production Software */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".4s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-2"
                titleClass="service__title color-2"
                descClass="text-white"
                serviceIcon="fal fa-industry"
                serviceIconBg={serviceIconBg2}
                Title="Production Software"
                Description="Optimize your manufacturing processes with tailored production software that improves workflow, minimizes downtime, and boosts overall productivity."
                btnText="Read More"
                btnURL="services/production-software"
              />
            </div>
            {/* Service 3: Asset Management Software */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-3"
                titleClass="service__title color-3"
                descClass="text-white"
                serviceIcon="fal fa-tv"
                serviceIconBg={serviceIconBg3}
                Title="Asset Management Software"
                Description="Efficiently track, monitor, and optimize asset utilization with our robust software solution, ensuring maximum ROI on your investments."
                btnText="Read More"
                btnURL="services/asset-management"
              />
            </div>
            {/* Service 4: Barcoding Software */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".6s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-4"
                titleClass="service__title color-4"
                descClass="text-white"
                serviceIcon="fal fa-barcode" // ideally a barcode icon
                serviceIconBg={serviceIconBg4}
                Title="Barcoding Software"
                Description="Implement advanced barcoding technology to streamline inventory tracking and reduce errors, ensuring precise control over your stock."
                btnText="Read More"
                btnURL="services/barcoding-software"
              />
            </div>
            {/* Service 5: Attendance Software */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-5"
                titleClass="service__title color-5"
                descClass="text-white"
                serviceIcon="fas fa-user-check" // ideally an attendance icon
                serviceIconBg={serviceIconBg5}
                Title="Attendance Software"
                Description="Simplify time tracking and workforce management with our intuitive attendance solution that enhances accuracy and streamlines payroll."
                btnText="Read More"
                btnURL="services/attendance-software"
              />
            </div>
            {/* Service 6: Inventory Management Software */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".8s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-6"
                titleClass="service__title color-6"
                descClass="text-white"
                serviceIcon="fal fa-warehouse" // ideally an inventory icon
                serviceIconBg={serviceIconBg6}
                Title="Inventory Management Software"
                Description="Streamline your supply chain with real-time inventory tracking that minimizes waste and optimizes stock levels for maximum profitability."
                btnText="Read More"
                btnURL="services/inventory-management"
              />
            </div>
            {/* Service 7: Mobile Application Development */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".9s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-7"
                titleClass="service__title color-7"
                descClass="text-white"
                serviceIcon="fas fa-mobile-alt"
                serviceIconBg={serviceIconBg7}
                Title="Mobile Application Development"
                Description="Engage your customers on-the-go with our innovative mobile apps, crafted to deliver seamless user experiences and drive business growth."
                btnText="Read More"
                btnURL="services/mobile-app-development"
              />
            </div>
            {/* Service 8: Custom Software Development */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay="1.0s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-8"
                titleClass="service__title color-8"
                descClass="text-white"
                serviceIcon="fas fa-code"
                serviceIconBg={serviceIconBg8}
                Title="Custom Software Development"
                Description="Receive bespoke software solutions designed specifically to address your unique business challenges and accelerate your digital transformation journey."
                btnText="Read More"
                btnURL="services/custom-software"
              />
            </div>
            {/* Service 9: IT Consulting Services */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay="1.1s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-9"
                titleClass="service__title color-9"
                descClass="text-white"
                serviceIcon="fas fa-comments"
                serviceIconBg={serviceIconBg9}
                Title="IT Consulting Services"
                Description="Benefit from our expert IT consulting services that guide your digital strategy and ensure seamless technology integration within your business."
                btnText="Read More"
                btnURL="services/it-consulting"
              />
            </div>
            {/* Service 10: Digital Transformation */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay="1.2s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-10"
                titleClass="service__title color-10"
                descClass="text-white"
                serviceIcon="fas fa-sync-alt"
                serviceIconBg={serviceIconBg10}
                Title="Digital Transformation"
                Description="Accelerate your business growth by modernizing legacy systems through innovative digital transformation strategies and agile technology integration."
                btnText="Read More"
                btnURL="services/digital-transformation"
              />
            </div>
            {/* Service 11: Data Analytics & Reporting */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay="1.3s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-11"
                titleClass="service__title color-11"
                descClass="text-white"
                serviceIcon="fas fa-chart-line"
                serviceIconBg={serviceIconBg11}
                Title="Data Analytics & Reporting"
                Description="Transform raw data into actionable insights with our advanced analytics solutions that empower you to make informed, strategic business decisions."
                btnText="Read More"
                btnURL="services/data-analytics"
              />
            </div>
            {/* Service 12: Cloud Solutions */}
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay="1.4s"
            >
              <SingleService
                itemClass="service__item service__item-bg p-relative fix shape-none"
                btnClass="service__link service__link-color-12"
                titleClass="service__title color-12"
                descClass="text-white"
                serviceIcon="fas fa-cloud"
                serviceIconBg={serviceIconBg12}
                Title="Cloud Solutions"
                Description="Embrace scalable, secure, and cost-effective cloud solutions that enable your business to operate seamlessly in a digital-first environment."
                btnText="Read More"
                btnURL="services/cloud-solutions"
              />
            </div>
          </div>
        </div>
      </div>

      <CTA
        ctaBG={bgImg}
        Title="Discover Our Comprehensive Software Solutions"
        Description="Explore our wide range of services – from ERP & CRM systems to custom software development – designed to streamline your operations and drive digital transformation for your business."
        btnText="Explore Services"
        btnURL="services"
      />
    </main>
  );
};

export default ServiceMain;
